export const PRODUCT_CTA_LABEL_ID = 'checkAvailability';
